import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";

export interface MutateOrganizationDeleteParams {
  id: number;
}

export const mutateOrganizationDelete = async (values: MutateOrganizationDeleteParams) => {
  const { id } = values;
  const response = await makeMutation(
    ApiEndpoints.organizationOne(id),
    null,
    true,
    "DELETE"
  );
  return { success: response.success };
};
